// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2QFKk","title":"FrontImage_title__1BYjr"};